// Layout.js
import { Box } from "@mui/material";
import PersistentDrawerLeft from "./DesktopNavigation";

const Layout = ({ children, open, handleDrawerOpen, handleDrawerClose }) => {
  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <PersistentDrawerLeft
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        sx={{ overflow: "hidden" }}
      />

      <div>{children}</div>
    </Box>
  );
};

export default Layout;


